/* ==========================================================================
   Navigation - Asian American Forward Website
   ========================================================================== */

export function initializeNavigation() {
  console.log('🧭 Initializing navigation...');
  
  const navToggle = document.querySelector('.nav-toggle');
  const navMenu = document.querySelector('.nav-menu');
  
  if (!navToggle || !navMenu) {
    console.warn('Navigation elements not found');
    return;
  }
  
  // Function to reset mobile menu state
  function resetMobileMenu() {
    navToggle.setAttribute('aria-expanded', 'false');
    navMenu.classList.remove('expanded');
  }
  
  // Mobile menu toggle
  navToggle.addEventListener('click', function() {
    const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
    
    navToggle.setAttribute('aria-expanded', !isExpanded);
    navMenu.classList.toggle('expanded');
  });
  
  // Close menu when clicking on links
  const navLinks = document.querySelectorAll('.nav-link');
  navLinks.forEach(link => {
    link.addEventListener('click', function() {
      resetMobileMenu();
    });
  });
  
  // Reset mobile menu when window is resized to desktop size
  window.addEventListener('resize', function() {
    const isDesktop = window.innerWidth > 768;
    if (isDesktop) {
      resetMobileMenu();
      // Clear any inline styles that might interfere with CSS
      navMenu.style.removeProperty('display');
      navMenu.style.removeProperty('transform');
      navMenu.style.removeProperty('opacity');
      navMenu.style.removeProperty('visibility');
    }
  });
  
  // Ensure mobile menu starts closed
  resetMobileMenu();
  
  // Logo click behavior - navigate to home or scroll to top
  const logoLink = document.querySelector('.logo-link');
  if (logoLink) {
    logoLink.addEventListener('click', function(e) {
      // Check if we're on the home page (index.html)
      const isHomePage = window.location.pathname.endsWith('index.html') || 
                        window.location.pathname.endsWith('/') ||
                        window.location.pathname === '';
      
      if (isHomePage) {
        // On home page: scroll to top
        e.preventDefault();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
      // On other pages: let the default navigation happen (go to index.html)
    });
  }
  
  // Home button click to scroll to top (same as logo)
  const homeLink = document.querySelector('.nav-link-home');
  if (homeLink) {
    homeLink.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default anchor behavior and hash in URL
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
  
  console.log('✅ Navigation initialized');
} 